import React from "react"
import Hr from "@irati/ui/src/Layout/Hr"
import {Row, RowMiddle, RowStart} from "."

const UserHr = () => {
  return (
    <Row>
      <RowStart />
      <RowMiddle>
        <Hr small />
      </RowMiddle>
    </Row>
  )
}

export default UserHr
